// extracted by mini-css-extract-plugin
export default {"container":"style_container__2VMfS","colored":"style_colored__o3yxN","transparent":"style_transparent__AIrVg"};